// Auto-generated jersey design catalogue from Customade PDF patterns.
// 5 collections x 20 designs = 100 indicative patterns.
export const DESIGNS = [
  { id: "A-01", src: "/designs/set2-p001-001.jpg", collection: "A" },
  { id: "A-02", src: "/designs/set2-p026-026.jpg", collection: "A" },
  { id: "A-03", src: "/designs/set2-p051-051.jpg", collection: "A" },
  { id: "A-04", src: "/designs/set2-p076-076.jpg", collection: "A" },
  { id: "A-05", src: "/designs/set2-p101-101.jpg", collection: "A" },
  { id: "A-06", src: "/designs/set2-p126-126.jpg", collection: "A" },
  { id: "A-07", src: "/designs/set2-p151-151.jpg", collection: "A" },
  { id: "A-08", src: "/designs/set2-p176-176.jpg", collection: "A" },
  { id: "A-09", src: "/designs/set2-p201-201.jpg", collection: "A" },
  { id: "A-10", src: "/designs/set2-p226-226.jpg", collection: "A" },
  { id: "A-11", src: "/designs/set2-p251-251.jpg", collection: "A" },
  { id: "A-12", src: "/designs/set2-p276-276.jpg", collection: "A" },
  { id: "A-13", src: "/designs/set2-p301-301.jpg", collection: "A" },
  { id: "A-14", src: "/designs/set2-p326-326.jpg", collection: "A" },
  { id: "A-15", src: "/designs/set2-p351-351.jpg", collection: "A" },
  { id: "A-16", src: "/designs/set2-p376-376.jpg", collection: "A" },
  { id: "A-17", src: "/designs/set2-p401-401.jpg", collection: "A" },
  { id: "A-18", src: "/designs/set2-p426-426.jpg", collection: "A" },
  { id: "A-19", src: "/designs/set2-p451-451.jpg", collection: "A" },
  { id: "A-20", src: "/designs/set2-p476-476.jpg", collection: "A" },
  { id: "B-01", src: "/designs/set3-p001-001.jpg", collection: "B" },
  { id: "B-02", src: "/designs/set3-p026-026.jpg", collection: "B" },
  { id: "B-03", src: "/designs/set3-p051-051.jpg", collection: "B" },
  { id: "B-04", src: "/designs/set3-p076-076.jpg", collection: "B" },
  { id: "B-05", src: "/designs/set3-p101-101.jpg", collection: "B" },
  { id: "B-06", src: "/designs/set3-p126-126.jpg", collection: "B" },
  { id: "B-07", src: "/designs/set3-p151-151.jpg", collection: "B" },
  { id: "B-08", src: "/designs/set3-p176-176.jpg", collection: "B" },
  { id: "B-09", src: "/designs/set3-p201-201.jpg", collection: "B" },
  { id: "B-10", src: "/designs/set3-p226-226.jpg", collection: "B" },
  { id: "B-11", src: "/designs/set3-p251-251.jpg", collection: "B" },
  { id: "B-12", src: "/designs/set3-p276-276.jpg", collection: "B" },
  { id: "B-13", src: "/designs/set3-p301-301.jpg", collection: "B" },
  { id: "B-14", src: "/designs/set3-p326-326.jpg", collection: "B" },
  { id: "B-15", src: "/designs/set3-p351-351.jpg", collection: "B" },
  { id: "B-16", src: "/designs/set3-p376-376.jpg", collection: "B" },
  { id: "B-17", src: "/designs/set3-p401-401.jpg", collection: "B" },
  { id: "B-18", src: "/designs/set3-p426-426.jpg", collection: "B" },
  { id: "B-19", src: "/designs/set3-p451-451.jpg", collection: "B" },
  { id: "B-20", src: "/designs/set3-p476-476.jpg", collection: "B" },
  { id: "C-01", src: "/designs/set5-p001-001.jpg", collection: "C" },
  { id: "C-02", src: "/designs/set5-p026-026.jpg", collection: "C" },
  { id: "C-03", src: "/designs/set5-p051-051.jpg", collection: "C" },
  { id: "C-04", src: "/designs/set5-p076-076.jpg", collection: "C" },
  { id: "C-05", src: "/designs/set5-p101-101.jpg", collection: "C" },
  { id: "C-06", src: "/designs/set5-p126-126.jpg", collection: "C" },
  { id: "C-07", src: "/designs/set5-p151-151.jpg", collection: "C" },
  { id: "C-08", src: "/designs/set5-p176-176.jpg", collection: "C" },
  { id: "C-09", src: "/designs/set5-p201-201.jpg", collection: "C" },
  { id: "C-10", src: "/designs/set5-p226-226.jpg", collection: "C" },
  { id: "C-11", src: "/designs/set5-p251-251.jpg", collection: "C" },
  { id: "C-12", src: "/designs/set5-p276-276.jpg", collection: "C" },
  { id: "C-13", src: "/designs/set5-p301-301.jpg", collection: "C" },
  { id: "C-14", src: "/designs/set5-p326-326.jpg", collection: "C" },
  { id: "C-15", src: "/designs/set5-p351-351.jpg", collection: "C" },
  { id: "C-16", src: "/designs/set5-p376-376.jpg", collection: "C" },
  { id: "C-17", src: "/designs/set5-p401-401.jpg", collection: "C" },
  { id: "C-18", src: "/designs/set5-p426-426.jpg", collection: "C" },
  { id: "C-19", src: "/designs/set5-p451-451.jpg", collection: "C" },
  { id: "C-20", src: "/designs/set5-p476-476.jpg", collection: "C" },
  { id: "D-01", src: "/designs/set6-p001-001.jpg", collection: "D" },
  { id: "D-02", src: "/designs/set6-p026-026.jpg", collection: "D" },
  { id: "D-03", src: "/designs/set6-p051-051.jpg", collection: "D" },
  { id: "D-04", src: "/designs/set6-p076-076.jpg", collection: "D" },
  { id: "D-05", src: "/designs/set6-p101-101.jpg", collection: "D" },
  { id: "D-06", src: "/designs/set6-p126-126.jpg", collection: "D" },
  { id: "D-07", src: "/designs/set6-p151-151.jpg", collection: "D" },
  { id: "D-08", src: "/designs/set6-p176-176.jpg", collection: "D" },
  { id: "D-09", src: "/designs/set6-p201-201.jpg", collection: "D" },
  { id: "D-10", src: "/designs/set6-p226-226.jpg", collection: "D" },
  { id: "D-11", src: "/designs/set6-p251-251.jpg", collection: "D" },
  { id: "D-12", src: "/designs/set6-p276-276.jpg", collection: "D" },
  { id: "D-13", src: "/designs/set6-p301-301.jpg", collection: "D" },
  { id: "D-14", src: "/designs/set6-p326-326.jpg", collection: "D" },
  { id: "D-15", src: "/designs/set6-p351-351.jpg", collection: "D" },
  { id: "D-16", src: "/designs/set6-p376-376.jpg", collection: "D" },
  { id: "D-17", src: "/designs/set6-p401-401.jpg", collection: "D" },
  { id: "D-18", src: "/designs/set6-p426-426.jpg", collection: "D" },
  { id: "D-19", src: "/designs/set6-p451-451.jpg", collection: "D" },
  { id: "D-20", src: "/designs/set6-p476-476.jpg", collection: "D" },
  { id: "E-01", src: "/designs/setA-p001-001.jpg", collection: "E" },
  { id: "E-02", src: "/designs/setA-p026-026.jpg", collection: "E" },
  { id: "E-03", src: "/designs/setA-p051-051.jpg", collection: "E" },
  { id: "E-04", src: "/designs/setA-p076-076.jpg", collection: "E" },
  { id: "E-05", src: "/designs/setA-p101-101.jpg", collection: "E" },
  { id: "E-06", src: "/designs/setA-p126-126.jpg", collection: "E" },
  { id: "E-07", src: "/designs/setA-p151-151.jpg", collection: "E" },
  { id: "E-08", src: "/designs/setA-p176-176.jpg", collection: "E" },
  { id: "E-09", src: "/designs/setA-p201-201.jpg", collection: "E" },
  { id: "E-10", src: "/designs/setA-p226-226.jpg", collection: "E" },
  { id: "E-11", src: "/designs/setA-p251-251.jpg", collection: "E" },
  { id: "E-12", src: "/designs/setA-p276-276.jpg", collection: "E" },
  { id: "E-13", src: "/designs/setA-p301-301.jpg", collection: "E" },
  { id: "E-14", src: "/designs/setA-p326-326.jpg", collection: "E" },
  { id: "E-15", src: "/designs/setA-p351-351.jpg", collection: "E" },
  { id: "E-16", src: "/designs/setA-p376-376.jpg", collection: "E" },
  { id: "E-17", src: "/designs/setA-p401-401.jpg", collection: "E" },
  { id: "E-18", src: "/designs/setA-p426-426.jpg", collection: "E" },
  { id: "E-19", src: "/designs/setA-p451-451.jpg", collection: "E" },
  { id: "E-20", src: "/designs/setA-p476-476.jpg", collection: "E" },
];

export const COLLECTIONS = [
  { key: "ALL", label: "All patterns" },
  { key: "A", label: "Collection A" },
  { key: "B", label: "Collection B" },
  { key: "C", label: "Collection C" },
  { key: "D", label: "Collection D" },
  { key: "E", label: "Collection E" },
];
